import axios from '../../../utils/AxiosUtils';
import i18n from '../../../i18next';
import MessageUtils from "../../../utils/MessageUtils";
import {
    LOADING,
    LOAD_CATEGORIES_SUCCESS,
    REORDER_CATEGORIES_SUCCESS,
    RESET_CATEGORIES,
    RESET_PRODUCTS,
    RESET_QUESTIONS,
    RESET_ANSWERS,
    RESET_SUB_QUESTIONS,
    RESET_SUB_ANSWERS,
    LOAD_CATEGORIES_FOR_CSV_CREATE_EDIT_SUCCESS,
    RESET_PRODUCTS_FOR_CSV_CREATE_EDIT_SUCCESS
} from '../../types';
import { convertStringToBoolean, convertNotEmptyStringToNumber } from "../../../utils/CommonUtils";

export const loadCategories = (menuId, excludeMealDeal, saveInMenuProductCategoryReducer) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        let excludeMealDealParameter = '';

        if (excludeMealDeal) {
            excludeMealDealParameter = `?excludeMealDeal=${excludeMealDeal}`
        }

        const url = `/menu-draft/${menuId}/categories${excludeMealDealParameter}`;

        axios().get(url)
            .then(response => {
                if (saveInMenuProductCategoryReducer) {
                    loadCategoriesInMenuCategoryProductReducer(dispatch, response);
                } else {
                    loadCategoriesSuccess(dispatch, response);
                }
            })
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:categoriesActions.loadCategoriesFailure')));
    }
}

const loadCategoriesInMenuCategoryProductReducer = (dispatch, response) => {
    dispatch({ type: RESET_PRODUCTS_FOR_CSV_CREATE_EDIT_SUCCESS });
    dispatch({ type: LOAD_CATEGORIES_FOR_CSV_CREATE_EDIT_SUCCESS, payload: response.data });
    dispatch({ type: LOADING, payload: false });
}

const loadCategoriesSuccess = (dispatch, response, saveMessageSuccess, deleteMessageSuccess, publishMessageSuccess, stateId, formData) => {

    if (saveMessageSuccess !== undefined && saveMessageSuccess !== null && saveMessageSuccess === true) {
        if (formData !== null) {
            // console.log('loadProductsSuccess formData !== null ', formData);
            doUploadCategoryImage(stateId, formData, dispatch);
        } else {
            MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:categoriesActions.saveCategorySuccess'));
        }
    }

    if (deleteMessageSuccess !== undefined && deleteMessageSuccess !== null && deleteMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:categoriesActions.deleteCategorySuccess'));
    }

    if (publishMessageSuccess !== undefined && publishMessageSuccess !== null && publishMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:categoriesActions.publishCategorySuccess'));
    }

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: RESET_PRODUCTS });
    dispatch({ type: RESET_QUESTIONS });
    dispatch({ type: RESET_ANSWERS });
    dispatch({ type: RESET_SUB_QUESTIONS });
    dispatch({ type: RESET_SUB_ANSWERS });
    dispatch({ type: LOAD_CATEGORIES_SUCCESS, payload: response.data });
}

export const saveCategory = (state, restaurantId, formData, invalidSubmit, publishCategoryCallback, saveCategoryCallbackOnSuccess, deleteImageArgument) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });
        const {
            id,
            menuDraftId,
            name,
            description,
            active,
            minimumQuantity,
            multipleActivateOrDeactivate,
            multipleNameChange,
            multipleDescriptionChange,
            categoryAvailableAllDay,
            availableTimes } = state;

        if (!state.categoryAvailableAllDay && !state.availableTimes.length) {

            MessageUtils.errorMessageResponse(dispatch, undefined, i18n.t('actions:menusActions.noOpeningHours'));
            return;
        }

        const categoryData = {
            restaurantId: Number(restaurantId),
            menuDraftId: menuDraftId,
            name: name,
            description: description,
            minimumQuantity: !convertNotEmptyStringToNumber(minimumQuantity) ? '' : convertNotEmptyStringToNumber(minimumQuantity),
            active: convertStringToBoolean(active),
            multipleActivateOrDeactivate: convertStringToBoolean(multipleActivateOrDeactivate),
            multipleNameChange: convertStringToBoolean(multipleNameChange),
            multipleDescriptionChange: convertStringToBoolean(multipleDescriptionChange),
            categoryAvailableAllDay: categoryAvailableAllDay,
            availableTimes: availableTimes
        };

        if (invalidSubmit) {
            MessageUtils.errorMessageResponse(dispatch, undefined, i18n.t('actions:menusActions.saveMenuFailure'));
            return;
        }

        if (id === -1) {
            const url = `/category-draft`;

            axios().post(url, categoryData)
                .then(response => saveCategorySuccess(dispatch, response, state.menuDraftId, publishCategoryCallback, saveCategoryCallbackOnSuccess, id, formData, deleteImageArgument))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:categoriesActions.saveNewCategoryFailure')));
        } else {
            const url = `/category-draft/${id}`;

            axios().put(url, categoryData)
                .then(response => saveCategorySuccess(dispatch, response, state.currentМenuDraftId, publishCategoryCallback, saveCategoryCallbackOnSuccess, id, formData, deleteImageArgument))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:categoriesActions.saveCategoryFailure')));
        }
    }
}

const saveCategorySuccess = (dispatch, response, menuDraftId, publishCategoryCallback, saveCategoryCallbackOnSuccess, categoryId, formData, deleteImageArgument) => {

    if (publishCategoryCallback) {

        doUploadCategoryImage(categoryId, formData, dispatch, publishCategoryCallback);
        // publishCategoryCallback();
        return;
    }

    if (saveCategoryCallbackOnSuccess) {

        saveCategoryCallbackOnSuccess();
    } else if (!formData && !saveCategoryCallbackOnSuccess && !publishCategoryCallback && deleteImageArgument) {

        deleteCategoryImage(dispatch, categoryId, () => {
            deleteImageArgument();
            loadCategories();
        })
        return;
    }

    if (formData) {

        doUploadCategoryImage(response.data.id, formData, dispatch, () => {
            const url = `/menu-draft/${menuDraftId}/categories`;

            axios().get(url)
                .then(response => loadCategoriesSuccess(dispatch, response, menuDraftId, formData))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:categoriesActions.loadCategoriesFailure')));
        })
    } else {

        const url = `/menu-draft/${menuDraftId}/categories`;

        axios().get(url)
            .then(response => loadCategoriesSuccess(dispatch, response, true, false, false, menuDraftId, formData))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:categoriesActions.loadCategoriesFailure')));
    }
}

export const deleteCategory = (state) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const { menuDraftId, id } = state;
        const url = `/category-draft/${id}`;

        axios().delete(url)
            .then(response => deleteCategorySuccess(dispatch, menuDraftId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:categoriesActions.deleteCategoryFailure')));
    }
}

const deleteCategorySuccess = (dispatch, menuDraftId) => {

    const url = `/menu-draft/${menuDraftId}/categories`;

    axios().get(url)
        .then(response => loadCategoriesSuccess(dispatch, response, false, true))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:categoriesActions.loadCategoriesFailure')));
}

export const publishCategory = (state, menuDraftIdFromProps) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });
        let currentMenuDraftId;

        const { menuDraftId, id } = state;

        currentMenuDraftId = menuDraftIdFromProps ? menuDraftIdFromProps : menuDraftId;
        const url = `/category-draft/${id}/publish`;

        axios().put(url, {})
            .then(response => publishCategorySuccess(dispatch, response, currentMenuDraftId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:categoriesActions.loadCategoriesFailure')));
    }
}

const publishCategorySuccess = (dispatch, response, currentMenuDraftId) => {

    if (response.data.code === 403) {
        MessageUtils.errorMessageResponse(dispatch, response.data, i18n.t('actions:menusActions.alreadyRunningPublish'))
    } else {
        const url = `/menu-draft/${currentMenuDraftId}/categories`;

        axios().get(url)
            .then(response => loadCategoriesSuccess(dispatch, response, false, false, true))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:categoriesActions.publishCategoryFailure')));
    }
}

export const reorderCategories = (categories, menuId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/menu-draft/${menuId}/categories/reorder`;

        axios().put(url, categories)
            .then(response => reorderCategoriesSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:categoriesActions.reorderItemsFailure')));
    }
}

const reorderCategoriesSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: REORDER_CATEGORIES_SUCCESS, payload: response.data });
}

export const resetCategories = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: RESET_CATEGORIES });
    }
}

export const uploadCategoryImage = (stateId, formData) => {
    return (dispatch) => {
        doUploadCategoryImage(stateId, formData, dispatch);
    }
}

const doUploadCategoryImage = (stateId, formData, dispatch, callback) => {
    if (formData) {
        const url = `/category-draft/${stateId}/upload-main-image`;
        const newFormData = new FormData();
        newFormData.append('file', formData);

        axios().put(url, newFormData)
            .then(response => uploadCategoryImageSuccess(dispatch, response, callback))
            .catch(error => uploadCategoryImageFailure(dispatch, error));
    } else {
        callback();
    }

}

const uploadCategoryImageSuccess = (dispatch, response, callback) => {
    if (callback) {
        callback();
    }
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:categoriesActions.saveCategorySuccess'));
}

const uploadCategoryImageFailure = (dispatch, error) => {
    MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:productsActions.uploadImageFailure'));
}

const deleteCategoryImage = (dispatch, categoryId, callback) => {

    const url = `/category-draft/${categoryId}/delete-main-image`;

    axios().delete(url)
        .then(response => deleteCategoryImageSuccess(dispatch, response, callback))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:categoriesActions.deletingImageFailure')))
};

const deleteCategoryImageSuccess = (dispatch, response, callback) => {
    if (callback) {
        callback();
    }
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:categoriesActions.deletedImageSuccess'));
};



// WEBPACK FOOTER //
// ./src/actions/restaurants/posmenu/CategoriesActions.js